import React from 'react'
import TeamGroup from '../features/Teams/components/TeamGroup'

function Teams() {
  return (
    <div>
      <TeamGroup/>
    </div>
  )
}

export default Teams
